export enum BannerStatusEnum {
  Draft = 1,
  Active = 2,
  Inactive = 3,
}
